import styled, { css } from 'styled-components';
import UserInitials from '@/trio-ui/UserInitials';

type ActionButtonType = {
  isSaveButton?: boolean;
  isCancelButton?: boolean;
  withDangerAlert?: boolean;
};

const saveButtonCss = css`
  color: ${(props) => props.theme.colors['primary-60']};
  svg {
    fill: ${(props) => props.theme.colors['primary-60']};
  }
  &:hover {
    color: ${(props) => props.theme.colors['primary-40']};
    svg {
      fill: ${(props) => props.theme.colors['primary-40']};
    }
  }
`;

const redOnHover = css`
  &:hover {
    color: ${(props) => props.theme.colors['light-red']};
    svg {
      fill: ${(props) => props.theme.colors['light-red']};
    }
  }
`;

export const ActionButton = styled.button<ActionButtonType>`
  font-size: 14px;
  line-height: 21px;
  margin-right: 18px;
  display: flex;
  align-items: center;
  color: #6f7175;
  transition: all 0.3s ease;
  svg {
    width: 14px;
    margin-right: 3px;
    fill: #96979b;
  }
  &:hover {
    color: ${(props) => props.theme.colors['primary-60']};
    svg {
      fill: ${(props) => props.theme.colors['primary-60']};
    }
  }
  &:disabled {
    pointer-events: none;
  }
  ${({ withDangerAlert }) => withDangerAlert && redOnHover};
  ${({ isSaveButton }) => isSaveButton && saveButtonCss};
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 27px;
  margin-bottom: 0;
`;

export const NoteContent = styled(CardFooter)`
  margin-bottom: 12px;
`;

export const AddNewNoteButton = styled.button`
  color: ${(props) => props.theme.colors['primary-60']};
  font-size: 14px;
  line-height: 21px;
`;

export const CardAuthor = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  margin-right: 8px;
`;

export const PublishedAt = styled.p`
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-right: 12px;
  font-size: 10px;
  line-height: 14px;
  font-weight: 400;
`;

export const UserAvatar = styled(UserInitials)`
  width: 24px;
  height: 24px;
  border: 0;
  font-size: 8px;
  margin-right: 8px;
`;

export const Note = styled.div`
  &:not(&:last-child) {
    margin-bottom: 24px;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid;
  color: ${(props) => props.theme.colors['neutral-100']};
  border-color: ${(props) => props.theme.colors['neutral-40']};
  background-color: ${(props) => props.theme.colors['neutral-10']};
  border-radius: 5px;
  padding: 12px;
  font-size: 14px;
  line-height: 21px;
  min-height: 44px;

  &:disabled {
    padding: 0;
    border: 0;
  }

  &:active,
  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors['primary-60']};
  }
`;

export const NoteContentText = styled.p`
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  margin-bottom: 12px;
  white-space: pre-wrap;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
